import { render } from "./FullScreenSliderComp2.vue?vue&type=template&id=5ea106c4&scoped=true"
import script from "./FullScreenSliderComp2.vue?vue&type=script&lang=js"
export * from "./FullScreenSliderComp2.vue?vue&type=script&lang=js"

import "./FullScreenSliderComp2.vue?vue&type=style&index=0&id=5ea106c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ea106c4"]])

export default __exports__